import { useEffect } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import "@/App.css";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      if (hash) {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo(0, 0);
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}

function SiteFrame({ children }) {
  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="page-main">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<SiteFrame><HomePage /></SiteFrame>} />
        <Route path="/kontakt" element={<SiteFrame><ContactPage /></SiteFrame>} />
        <Route path="/impressum" element={<SiteFrame><LegalPage kind="impressum" /></SiteFrame>} />
        <Route path="/datenschutz" element={<SiteFrame><LegalPage kind="datenschutz" /></SiteFrame>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
